<template>
  <BaseAttachmentList :attachments="attachments" :loading="false">
    <template #actions>
      <WorkOrderAttachmentForm :id="id" />
    </template>
  </BaseAttachmentList>
</template>

<script>
import WorkOrderAttachmentForm from "./WorkOrderAttachmentForm";
import BaseAttachmentList from "../Attachments/BaseAttachmentList";
export default {
  name: "WorkOrderAttachmentList",
  components: { BaseAttachmentList, WorkOrderAttachmentForm },
  props: {
    id: {
      type: [Number, String],
      required: true
    },
    attachments: {
      type: [Array],
      required: true
    }
  }
};
</script>
